// 上传文件相关api
/* eslint-disable */
export default {
  basePath: process.env.VUE_APP_UPLOAD_URL,
  apiList: {
    // 上传文件
    TMC_POST_UPLOAD_FILE: "api/sys/file"
  }
};
